import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, animate, transition, style } from '@angular/animations';

import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ClientService } from '../create-client/client.service';
import { AdvisorBarService } from '../shared/advisor-bar/advisor-bar.service';
import { ModalComponent } from '../shared/modal/modal.component';
import { LoadingService } from '../shared/loading/loading.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



import { PagerService } from '../services/pager.service';

@Component({
  selector: 'app-new-illustration-options',
  templateUrl: './new-illustration-options.component.html',
  styleUrls: ['./new-illustration-options.component.css']
})
export class NewIllustrationOptionsComponent implements OnInit {

  public tempHCData: any;
  public error: string;
  public partnerActive: boolean = false;
  public client: any;

  clientSpouseFullName;
public clients: any[];
public filteredClients: any[];
public selectedClient: any = {};
public reports: any[] = [];
public modalSubscription;
public loadingSubscription;
public previousUrl: string;
public pager: any = {};
public pagedItems: any[];

  private navCards = [
    { title: 'On-Screen Illustration', description: 'Run a full client projection with additional inputs (plus a PDF download)', urlOverride: '', icon: 'fa-ambulance', color: '#a4b7d6', iconColor: '#3385C5', image:'../../../assets/icons/on_screen.svg', isCreateReport:true },
    { title: 'Quick PDF Illustration', description: 'Just a few inputs delivers a personalized PDF report', urlOverride: '/clients/edit/combined/options/hcltc', icon: 'fa-university', color: '#bdaee0', iconColor: '#9578E3', image:'../../../assets/icons/pdf.svg', isCreateReport:true }
  ]

  constructor(private clientService: ClientService, private dialog: MatDialog, private advisorBarService: AdvisorBarService, private globalService: GlobalService, private modalService: ModalService,  
    private pagerService: PagerService, private router: Router, private snackBarService: SnackBarService, private loadingService: LoadingService, private route: ActivatedRoute) {
      this.globalService.featQuickReports = JSON.parse(localStorage.getItem('featQuickReports'));
      this.globalService.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));
      if(!this.globalService.featQuickReports){
        this.navCards.pop();

        if(this.globalService.featRiskTolerance){
          this.navCards.push(
            { title: 'On-Screen Illustration w/Asset Management', description: 'Run a full client projection with Asset Management (plus a PDF download)', 
              urlOverride: '', 
              icon: 'fa-ambulance', color: '#a4b7d6', iconColor: '#3385C5', image:'../../../assets/icons/on_screen.svg', isCreateReport:true }
          );
        }
      } else {
        //if QR AND RT are both avail for this org, we want RT card to be right after the existing 'on-screen card', and then the QR card last
        if(this.globalService.featRiskTolerance){
          const newObject = { title: 'On-Screen Illustration w/Asset Management', description: 'Run a full client projection with Asset Management (plus a PDF download)', 
                urlOverride: '', icon: 'fa-ambulance', color: '#a4b7d6', iconColor: '#3385C5', image:'../../../assets/icons/on_screen.svg', isCreateReport:true };
          const insertIndex: number = 1;
          this.navCards.splice(insertIndex, 0, newObject);
        }
      }

      this.getClients();
      localStorage.setItem('isCreateClient', "False");
      this.modalSubscription = modalService.modal$.subscribe((modal) => {
      
        if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClient(localStorage.getItem('selectedClient'));
      }
    });

    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  public isOA: boolean;
  public isS: boolean;
  public isA: boolean;
  public isHVS: boolean;
  

  ngOnDestroy() {
    
  }

  public role: Number;

  reportName;
  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));
    this.isOA = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;
    this.isA = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;
    this.isHVS = Number(localStorage.getItem('orgID')) === 1 ? true : false;

    if (localStorage.getItem('selectedClient')) {
      this.getClient(Number(localStorage.getItem('selectedClient')));
      this.getClientReports(Number(localStorage.getItem('selectedClient')));
    }

    //update the navCards array here
    if (this.router.url.includes("clients/edit/healthcare/options")) {
        this.reportName = "Healthcare";
        //this.router.navigate(['/reports/create/hc']);
        //this.navCards[0].urlOverride = "/reports/create/hc";
        //this.navCards[1].urlOverride = "/reports/create/hcq";      

        this.navCards[0].urlOverride = "/clients/edit/healthcare/options/hc";
        if(this.globalService.featQuickReports){
          this.navCards[1].urlOverride = "/clients/edit/healthcare/options/hcq";    
        }

        if(this.globalService.featRiskTolerance){
          if(this.globalService.featQuickReports){
            this.navCards[2].urlOverride = "/clients/edit/healthcare/options/hcq"; 
          }

          this.navCards[1].urlOverride = "/clients/edit/healthcare/options/hcrt"; 
        }

    } else if (this.router.url.includes("clients/edit/social-security/options")) {
        this.reportName = "Social Security";
        //this.router.navigate(['/reports/create/ss']);
        //this.navCards[0].urlOverride = "/reports/create/ss";
        //this.navCards[1].urlOverride = "/reports/create/ssq";

        this.navCards[0].urlOverride = "/clients/edit/social-security/options/ss";

        //TODO: remove when Quick for MMT is ready
        //this.navCards.pop();
        //TODO: add back when Quick for MMT is ready
        if(this.globalService.featQuickReports){
          this.navCards[1].urlOverride = "/clients/edit/social-security/options/ssq";
        }

    } else if (this.router.url.includes("clients/edit/medicare-means-testing/options")) {
        this.reportName = "Medicare Means Testing";
        //this.router.navigate(['/reports/create/mmtv2']);
        //this.navCards[0].urlOverride = "/reports/create/mmtq";
        this.navCards[0].urlOverride = "/clients/edit/medicare-means-testing/options/mmtv2";

        if(this.globalService.featQuickReports){
        //TODO: add back when Quick for MMT is ready
          this.navCards[1].urlOverride = "/clients/edit/medicare-means-testing/options/mmtq";
        }

        //TODO: remove when Quick for MMT is ready
        //this.navCards.pop();

    } else if (this.router.url.includes("clients/edit/long-term-care/options")) {
        this.reportName = "Long-Term Care";
        //this.router.navigate(['/reports/create/ltc']);
        //this.navCards[0].urlOverride = "/reports/create/ltc";
        //this.navCards[1].urlOverride = "/reports/create/ltcq";     

        this.navCards[0].urlOverride = "/clients/edit/long-term-care/options/ltc";
        if(this.globalService.featQuickReports){
          this.navCards[1].urlOverride = "/clients/edit/long-term-care/options/ltcq";   
        }

        if(this.globalService.featRiskTolerance){
          if(this.globalService.featQuickReports){
            this.navCards[2].urlOverride = "/clients/edit/long-term-care/options/ltcq"; 
          }

          this.navCards[1].urlOverride = "/clients/edit/long-term-care/options/ltcrt"; 
        }

    } else if (this.router.url.includes("clients/edit/combined/options")) {
        this.reportName = "Healthcare & Long-Term Care";
        //this.navCards[0].urlOverride = "/reports/create/combined";
        //this.navCards[1].urlOverride = "/reports/create/hcltc";

        this.navCards[0].urlOverride = "/clients/edit/combined/options/combined";
        if(this.globalService.featQuickReports){
          this.navCards[1].urlOverride = "/clients/edit/combined/options/hcltc";
        }

    }
  }

  getClients() {
    if (window.location.search.split('?')[1] != 'd=t')
      this.loadingService.isLoading(true);

    var spouses;

    this.globalService.getClientsData()
      .subscribe(
      clients => {
        this.clients = clients.map((item) => {
          if (item.c) {
            spouses = JSON.parse(item.cp.Spouses) || [];

            spouses.map((spouse) => {
              if (spouse.maritalStatus == 'Married') {
                item.c.spouseName = spouse.firstName + " " + spouse.lastName;
              }
            });

            return item.c;
          } else {
            return item;
          }
        });

        if (window.location.search.split('?')[1] != 'd=t')
          this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        
        if (window.location.search.split('?')[1] != 'd=t')
          this.loadingService.isLoading(false);
      });
  }

  getClientReports(userID: number) {

    this.globalService.getClientReportsData(userID)
      .subscribe(
      reports => {
        var allReports = [];

        for (var type in reports) {
          reports[type].forEach((report) => {
            allReports.push({
              reportID: report.r.ReportID,
              ID: report.r.ID,
              reportTypeID: report.r.ReportTypeID,
              createdDate: report.r.Created_Date,
              advisorID: report.r.AdvisorID,
            });
          });
        }

        allReports = allReports.sort(function(a, b) {
          return b.ID - a.ID;
        });

        this.reports = allReports;
        this.setPage(allReports.length ? 1 : 0);
      },
      error => this.error = <any>error);
  }

  filterItem(value) {
    this.filteredClients = Object.assign([], this.clients).filter(
      client => ((client.FirstName + " " + client.LastName + " " + client.spouseName).toLowerCase().includes(value.toLowerCase()))
    );
  }

  isClientMarried: boolean = false;
 

  getClient(userID) {
    this.isClientMarried = false;
    this.globalService.getClientData(userID, 4)
      .subscribe(
      client => {
        this.selectedClient = client;
        this.selectedClient.clientProfile.CurrentIncome = this.selectedClient.clientProfile.CurrentIncome ? Utils.formatToCurrency(this.selectedClient.clientProfile.CurrentIncome): this.selectedClient.clientProfile.CurrentIncome;
        this.selectedClient.clientProfile.Pension = this.selectedClient.clientProfile.Pension ? Utils.formatToCurrency(this.selectedClient.clientProfile.Pension): this.selectedClient.clientProfile.Pension;

        var spouses = JSON.parse(this.selectedClient.clientProfile.Spouses) || [];
        spouses.map((spouse) => {
          if (spouse.maritalStatus == 'Married') {
            this.isClientMarried = true;
            this.selectedClient.client.spouseName = spouse.firstName + " " + spouse.lastName;
            this.selectedClient.client.spouseDOB = spouse.dob;
            this.selectedClient.clientProfile.spouseLifeExpectancy = spouse.LifeExpectancy;
            this.selectedClient.clientProfile.spouseRetirementAge = spouse.retirementAge;
            //this.selectedClient.clientProfile.spouseCurrentIncome  = Utils.formatToCurrency(spouse.currentIncome);
            //this.selectedClient.clientProfile.spousePension = Utils.formatToCurrency(spouse.pension);
            /* if (this.selectedClient.clientProfile.spousePension.includes('$$')) { 
              //if has two, handle; this is an issue with older clients created on the tool
              this.selectedClient.clientProfile.spousePension = spouse.pension;
            } */
            
            this.selectedClient.clientProfile.spouseRetirementState  = spouse.state;
          }
        });
        console.log('client.clientProfile.Spouses[0].maritalStatus', spouses[0].maritalStatus);
        
        this.clientSpouseFullName = (spouses === undefined || spouses.length == 0)  ? client.client.FirstName + ' ' + client.client.LastName: (spouses[0].maritalStatus == 'Married' ?
        (client.client.LastName == spouses[0].lastName) ? 
              client.client.FirstName + ' and ' + spouses[0].firstName + ' ' + client.client.LastName :
              client.client.FirstName + ' ' + client.client.LastName + ' and ' + spouses[0].firstName + ' ' + spouses[0].lastName
              : client.client.FirstName + ' ' + client.client.LastName);
        console.log('this.clientSpouseFullName', this.clientSpouseFullName)

        localStorage.setItem('selectedClient', userID.toString())

        if (this.role == 1 || this.role == 2) {
          localStorage.setItem('selectedAdvisor', client.advisor.FirstName + " " + client.advisor.LastName);
          localStorage.setItem('selectedAdvisorID', client.advisor.ID);
          localStorage.setItem('selectedAdvisorOrgID', client.advisor.OrganizationID);
          this.advisorBarService.refresh();
        }

      },
      error => this.error = <any>error);
  }

  createReport(reportUrl) {
    this.router.navigate(['../reports/create/', reportUrl]);
  }

  selectClient(client, clientSearch) {
    clientSearch.value = client.spouseName ? client.FirstName + " " + client.LastName + " and " + client.spouseName : client.FirstName + " " + client.LastName;
    this.getClient(client.ID);
    this.getClientReports(client.ID);

    this.filteredClients = [];
  }

  handleEditClientModal(e, client) {

    this.router.navigate(['/clients/edit']);
    // this.clientService.add('add-edit-client', { ID: Number(localStorage.getItem('selectedClient')) });
  }
  
  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  formatReportTypeID(ReportTypeID: number) {
    return Utils.formatReportTypeID(ReportTypeID);
  }

  
  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() + ' ' + Utils.parseDateTime(date) : '--';
  }

  setPage(page: number) {
    if (!this.reports.length) {
      this.pager = [];
      this.pagedItems = [];
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.reports.length, page);

    // get current page of items
    this.pagedItems = this.reports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }



}
